module.exports = __webpack_public_path__ + "img/sun.2584676e.png";